import * as React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';

import { cn } from '@/lib/utils';

import { SelectContent } from './components/SelectContent';
import { SelectItem } from './components/SelectItem';
import { SelectTrigger } from './components/SelectTrigger';

interface Props
    extends SelectPrimitive.SelectProps,
        Omit<
            React.ComponentPropsWithoutRef<typeof SelectPrimitive.Content> &
                React.RefAttributes<HTMLDivElement>,
            'defaultValue' | 'dir'
        > {
    placeholder: string | React.ReactNode;
    dataTestId?: string;
}

const RadixSelect = SelectPrimitive.Root;

const Select: React.FC<Props> = ({
    children,
    onValueChange,
    placeholder,
    value,
    dataTestId,
    className,
    ...props
}) => (
    <RadixSelect
        onValueChange={onValueChange}
        value={value}
        data-test-id={dataTestId}
        {...props}
    >
        <SelectTrigger
            className={cn(
                'rounded-md border border-solid border-grey-200 font-medium',
                className,
            )}
        >
            <SelectPrimitive.Value placeholder={placeholder} />
        </SelectTrigger>

        {children}
    </RadixSelect>
);

export { Select, SelectContent, SelectItem };
